import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuth } from "@/hooks/useAuth";

/**
 * Redirects unauthenticated users to the home page (sign in via the map editor modal).
 * Returns the auth state so the caller can render loading UI while checking.
 */
export function useRequireAuth() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.loading && !auth.user) {
      navigate({ to: "/", replace: true });
    }
  }, [auth.loading, auth.user, navigate]);

  return auth;
}
